/**
 * Session-scoped PIN gate.
 * - Håller reda på om admin har verifierat sin PIN under de senaste 30 minuterna
 *   (sessionStorage — försvinner när fliken stängs).
 * - Används för att låsa känsliga åtgärder (godkänna tidrapporter, ÄTA, faktura).
 */
import { api } from './api';

const KEY = 'operio_pin_verified_at';
const WINDOW_MS = 30 * 60 * 1000; // 30 min

export const isPinVerified = () => {
  try {
    const v = sessionStorage.getItem(KEY);
    if (!v) return false;
    const ts = parseInt(v, 10);
    if (Number.isNaN(ts)) return false;
    return Date.now() - ts < WINDOW_MS;
  } catch {
    return false;
  }
};

export const markPinVerified = () => {
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // sessionStorage kan vara blockerat (privatläge). Ignorera.
  }
};

export const clearPinVerification = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {
    /* ignore */
  }
};

/**
 * Verifierar PIN mot backend och sparar timestamp vid framgång.
 * Kastar med Error(server-detail) vid fel.
 */
export const verifyPinRemote = async (pin) => {
  await api.verifyPin(pin);
  markPinVerified();
};

/**
 * Kollar först om PIN är verifierad i sessionen. Om nej → hämtar PIN-status från
 * backend. Om användaren INTE har någon PIN satt → skippa (returnera true).
 * Om användaren har PIN → returnera false så anroparen kan visa PIN-modalen.
 */
export const shouldPromptForPin = async () => {
  if (isPinVerified()) return false;
  try {
    const res = await api.getMyPinStatus();
    return !!res.data?.has_pin;
  } catch {
    return false;
  }
};
